import React, { useLayoutEffect, useMemo, useState, useEffect } from 'react';
import Loader from '@components/common/Loader/newLoaderModal';
import cn from 'classnames';
import { flowType } from '@utility/userInfo';
import { APP_CONFIG, COUNTRY_CODE } from '@constants';
import LoyaltySignIn from '../../components/Loyalty/loyaltySignInCopy';
import LoyaltyKeyboard from '../../components/Loyalty/loyaltyKeyboardCopy';
import { getObjectValue } from '@utility/utills';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { LABEL } from '../../veriables';
import { handleLoyaltyInfo, setOrderLoyaltyType,loyaltyNewBalance, loyaltyNewAccountSignIn, loyaltyNewAccountSignUp } from '@reducers/loyalty';
import { showSuccessCheckMark, setErrorPopUp } from '@reducers/notification';
import LoyaltyBalanceOffers from '../../components/Loyalty/loyaltyBalanceOffersNewUi';
import EventEmitter from '@utility/eventSubscribers';
import { ReactComponent as Cross } from '@assets/images/cross.svg';
import styles from './viewreceipt.module.scss';
import { TouchableDiv } from '@components/common/Touchable';
import ModalHeader from '../../components/common/ModalHeader/index';
import LoyaltyWelcomeScreen from './loyaltyWelcomeScreen'
import { setPaymentCheck, setSeat } from '@reducers/orders';
import { updateLoyaltyCheck } from '@reducers/storeChecks';
const LoyaltyBalance = props => {
  const { handleLoyaltyInfo, orderingPortraitOrientation } = props;
  const loyaltyInfo = props?.auth?.loyaltyInfo;
  let storeImage = useMemo(() => {
    getObjectValue(
      () => JSON.parse(window.sessionStorage.getItem('auth'), ''),
      null
    );
  });
  // dont remove code
  // const ShowLandscapeMode =
  //   isServer &&
  //   props.deviceInfo?.deviceGroup?.startMode === 0 &&
  //   props.deviceInfo?.deviceGroup?.serverAppSettings?.landscapePaymentMode;
  const [loyaltyType, setLoyaltyType] = useState(1);
  const [joinMethod, setJoinMethod] = useState();
  const [loyaltyMethod, setLoyaltyMethod] = useState();
  const [joinClicked, setJoinClicked] = useState(false);
  const [alreadyMem, setAlreadyMem] = useState(true);
  const [countryCode, setCountryCode] = useState(() => {
    return getObjectValue(
      () => COUNTRY_CODE[props.auth?.country].dialCode,
      '1'
    );
  });
  const [loyaltyOffers, setLoyaltyOffers] = useState({});
  const themeNumber = getObjectValue(
    () => JSON.parse(window.sessionStorage.getItem('auth'))?.serverAppTheme,
    null
  );
  const auth = props.auth?.loyaltyInfo?.lookupMethods;
  const lookupMethods = auth?.length === 1;
  const [isLandScape, setIsLandScape] = useState(
    window.innerWidth > window.innerHeight
  );  
  useEffect(() => {
    const handleResize = () => {
      setIsLandScape(window.innerWidth > window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [])

  const pathname = window.location.pathname;  

  useLayoutEffect(() => {
    if (window.ReactNativeWebView) {
      if (orderingPortraitOrientation && pathname.includes('loyalty-balance')) {
        EventEmitter.changeOrientation({
          orientation: 'portrait',
        });
      } else {
      EventEmitter.changeOrientation({
        orientation: 'landscape',
      });
    }
  }
  }, []);

  const handleBackButton = () => {
    let temp = { isShow: true, url: () => setLoyaltyType(1) };
    return temp;
  };

  const handleRouteToChecKListing = () => {
    if (window.ReactNativeWebView) {
      EventEmitter.changeOrientation({
        orientation: 'landscape',
      });
    }
    props.navigate(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`, {
      replace: true,
    });

  };
  const handleBackToWelcome = () => {
    setJoinClicked(false);
    setAlreadyMem(false);
    setLoyaltyMethod(undefined); // reset method if needed
    setLoyaltyType(1); // show welcome again
  };

  const openLoyaltyKeyboard = type => {
    setJoinMethod(type);
    setLoyaltyType(4);
  };
  const handleLoyaltySignIn = (type) => {
    setLoyaltyMethod(type);
    if (props.auth?.loyaltyInfo?.lookupMethods?.length === 1) {
      // Only 1 lookup method — skip the method-selection screen (type 2) and go
      // straight to the keyboard (type 4), pre-setting the single method directly.
      setJoinMethod(props.auth.loyaltyInfo.lookupMethods[0]);
      setLoyaltyType(4);
    } else {
      setLoyaltyType(2);
    }
  };

  const getName = () => {
    const methodName = joinMethod;
    let name = methodName;
    if (methodName === 'phone') {
      name = 'PhoneNumber';
    } else if (methodName === 'type') {
      name = 'AccountNumber';
    } else if (methodName === 'email') {
      name = 'Email';
    }
    return name;
  };

  const getPlaceHolder = () => {
    const methodName = joinMethod;
    let name = methodName;
    if (methodName === 'phone') {
      name = LABEL().LS_PHONE;
    } else if (methodName === 'type') {
      name = LABEL().LS_ACCOUNT;
    } else if (methodName === 'email') {
      name = LABEL().LS_EMAIL;
    }
    return name;
  };

  const isImage = () =>
    !!(
      loyaltyInfo?.signUpImageUrl ||
      loyaltyInfo?.imageUrl ||
      storeImage?.imageUrl
    );


  //     case 'AccountNumber':
  //       payload.loyalty = {
  //         accountNumber: inputData,
  //         phoneNumber: '',
  //         emailAddress: '',
  //         method: 'type',
  //         countryCode,
  //       };
  //       break;

  //     default: // Email
  //       payload.loyalty = {
  //         accountNumber: '',
  //         phoneNumber: '',
  //         emailAddress: inputData,
  //         method: 'email',
  //         countryCode,
  //       };
  //       break;
  //   }


  const handleLoyaltySubmit = (inputData, fieldName, termsAccept) => {
    let dataToSend = {
      storeId: props.deviceInfo?.storeId,
      deviceId: props.deviceInfo?.deviceId,
      employeeId: props.userInfo?.id,
      countryCode,
      method: '',
      phoneNumber: '',
      emailAddress: '',
      accountNumber: '',
      securityCode: '',
    };

    switch (fieldName) {
      case 'PhoneNumber':
        dataToSend = {
          ...dataToSend,
          phoneNumber: inputData,
          method: 'phone',
        };
        break;

      case 'AccountNumber':
        dataToSend = {
          ...dataToSend,
          accountNumber: inputData,
          method: 'type',
        };
        break;

      default: // Email
        dataToSend = {
          ...dataToSend,
          emailAddress: inputData,
          method: 'email',
        };
        break;
    }

    if (loyaltyMethod === 'signIn') {
      props.loyaltyNewAccountSignIn(JSON.stringify(dataToSend))
        .then((res) => {
          window.sessionStorage.setItem('loyaltyData', JSON.stringify(res?.loyalty));
          props.updateLoyaltyCheck({
            ...props.check,
            ...res.check,
          });
          props.setPaymentCheck({
            ...res?.paymentCheck,
            loyalty: res?.loyalty,
            paymentCheck: res?.paymentCheck,
            loyalties: res?.check?.loyalties,
          });
          props.setSeat({
            ...props.seat,
            loyalty: res?.loyalty,
            seats: res?.check?.seats,
            paymentCheck: res?.paymentCheck,
            paymentChecks: res?.paymentChecks,
            loyalties: res?.check?.loyalties,
          });
          setLoyaltyOffers(res);
          setLoyaltyType(3);
        })
        .catch((err) => {
          props.handleLoyaltyInfo({ phoneNumber: null, email: null, type: null });
          props.setErrorPopUp({ res: err.message });
        });

    } else if (loyaltyMethod === 'signUp') {
      props.loyaltyNewAccountSignUp(JSON.stringify(dataToSend))
        .then((res) => {
          props.updateLoyaltyCheck({
            ...props.check,
            ...res.check,
          });
          props.setPaymentCheck({
            ...res?.paymentCheck,
            loyalty: res?.loyalty,
            paymentCheck: res?.paymentCheck,
          });
          props.setSeat({
            ...props.seat,
            loyalty: res?.loyalty,
            seats: res?.check?.seats,
            paymentCheck: res?.paymentCheck,
            paymentChecks: res?.paymentChecks,
            loyalties: res?.check?.loyalties,
          });
          setLoyaltyOffers(res);
          setLoyaltyType(3);
        })
        .catch((err) => {
          props.setErrorPopUp({ res: err.message });
        });
    }
  };

  const themeProperties = useMemo(() => {
    getObjectValue(
      () => JSON.parse(window.sessionStorage.getItem('themeProperties')),
      null
    );
  });
  const getTileHeaderByLoyaltyType = (loyaltyType, loyaltyMethod, loyaltyOffers) => {

    switch (loyaltyType) {
      case 1:
        return LABEL().LB_LOYALTY_PROGRAM;

      case 2:
        return loyaltyMethod === 'signIn'
          ? LABEL().LB_SIGN_IN_TO_LOYALTY
          : LABEL().LB_SIGN_UP_TO_LOYALTY;

      case 3:
        if (loyaltyMethod === 'offers') {
          return LABEL().LB_AVAILABLE_OFFERS;
        }
        return LABEL().LB_AVAILABLE_OFFERS;

      case 4:
        return loyaltyMethod === 'signIn'
          ? LABEL().LB_SIGN_IN
          : LABEL().LB_SIGN_UP;

      case 5:
        return LABEL().LB_AVAILABLE_OFFERS;

      default:
        return LABEL().LB_LOYALTY_PROGRAM;
    }
  };


  const handleLoyaltyFlow = type => {
    switch (type) {
      case 1:
        return (
          <LoyaltyWelcomeScreen
            serverAppTheme={props.serverAppTheme}
            themeProperties={themeProperties}
            onClose={handleBackButton}
            loyaltyInfo={loyaltyInfo}
            setLoyaltyMethod={setLoyaltyMethod}
            handleLoyaltySignIn={handleLoyaltySignIn}
            setJoinClicked={setJoinClicked}
            setAlreadyMem={setAlreadyMem}
            alreadyMem={alreadyMem}
            joinClicked={joinClicked}
            // isLandScape={isLandScape}
            navigate={props.navigate}
            flowType={flowType}
          />

        );
      case 2:
        return (
          <LoyaltySignIn
            loyaltyMethod={loyaltyMethod}
            loyaltyInfo={loyaltyInfo}
            openLoyaltyKeyboard={openLoyaltyKeyboard}
            storeImage={storeImage}
            joinClicked={false}
            alreadyMem={false}
            isLoyaltyBalance={true}
            serverAppTheme={props?.serverAppTheme}
            themeProperties={themeProperties}
            isLandScape={isLandScape}
            handleRouteToChecKListing={handleBackToWelcome}
          />
        );
      case 3:
        return (
          <LoyaltyBalanceOffers
            loyaltyOffers={loyaltyOffers}
            handleRouteToChecKListing={handleBackToWelcome}
            serverAppTheme={props?.serverAppTheme}
            isLandScape={isLandScape}
          />
        );
      default:
        return <div />;
    }
  };

  return (
    <>
      <div style={{
        color: '#000'
      }}>
        <ModalHeader
          // isTab={props?.seat?.tab}
          // stationName={props?.seat?.stationName}
          // tileHeader={loyaltyType === 1 ? LABEL().OLS_LOYALTY_PGM_HEADER : loyaltyType === 4 ? LABEL().LS_SIGN_IN : LABEL().LB_AVAILABLE_OFFERS}
          tileHeader={getTileHeaderByLoyaltyType(loyaltyType, loyaltyMethod || 'signIn', loyaltyOffers)}
        // seatNumber={props?.seat?.number}
        />


      </div>
      <div
        className={cn('col-12 col-md-12 p-0 row mx-0 h-100 rowReverse')}
        style={{
          background: themeNumber === '2' ? '#f5f7fb' : '#000',
        }}
      >
        {props.loading && <Loader />}
        {/* {loyaltyType !== 2 && loyaltyType !== 4 && !isLandScape &&  (
          <TouchableDiv
            className={cn(
              'position-fixed rounded d-flex justify-content-center align-items-center'
            )}
            style={{
              right: '1rem',
              top: '3rem',
              zIndex: '999',
              width: '2rem',
              height: '2rem',
              backgroundColor: props.serverAppTheme?.iconcolor_bg_box,
            }}
            role="presentation"
            onClick={e => {
              e.preventDefault();
              handleRouteToChecKListing();
            }}
          >
            <Cross
              fill={props.serverAppTheme?.iconcolor}
              width={24}
              height={24}
            />
          </TouchableDiv>
        )} */}
        <div
          className={cn(
            // ShowLandscapeMode ? 'col-12 col-md-12 px-1 py-2' : isLandScape ? 'col-12 px-0 h-100' : 'col-12 p-3 h-100'
            isLandScape ? 'col-12 px-0 h-100' : 'col-12 p-3 h-100'
          )}
        >
          <div
            className={cn(
              'row mx-0 rounded position-relative h-99',
              // ShowLandscapeMode && 'h-99',
              loyaltyType !== 2 &&
              loyaltyType !== 4 &&
              styles.loyaltyBalancePadding
            )}
          >
            {handleLoyaltyFlow(loyaltyType)}
            {loyaltyType === 4 && (
              <LoyaltyKeyboard
                countryCode={countryCode}
                joinMethod={joinMethod}
                handleLoyaltySubmit={handleLoyaltySubmit}
                name={getName()}
                placeHolder={getPlaceHolder()}
                handleCountryCodeChange={e => setCountryCode(e.id)}
                loyaltyInfo={loyaltyInfo}
                loyaltyMethod={'signIn'}
                handleBackButton={handleBackButton}
                // ShowLandscapeMode={ShowLandscapeMode}
                isImage={isImage}
                handleLoyaltyInfo={handleLoyaltyInfo}
                isLoyaltyBalance={true}
                serverAppTheme={props?.serverAppTheme}
                themeProperties={themeProperties}
                loyaltyType={loyaltyType}
                handleCancel={handleBackToWelcome}
                lookupMethods={lookupMethods}
                setErrorPopUp={props.setErrorPopUp}
                isLandScape={isLandScape}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = state => ({
  loading: state.loyalty.loading,
  auth: state.oauth.authInfo,
  deviceInfo: state.oauth.deviceInformation,
  userInfo: state.oauth.loggedInUserData,
  seat: state.orders.seats,
  serverAppTheme: state.theme.serverAppTheme,
  orderingPortraitOrientation: state.orders.orderingPortraitOrientation
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      handleLoyaltyInfo,
      loyaltyNewBalance,
      showSuccessCheckMark,
      setErrorPopUp,
      loyaltyNewAccountSignIn,
      loyaltyNewAccountSignUp,
      setOrderLoyaltyType,
      setPaymentCheck,
      updateLoyaltyCheck,
      setSeat
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(LoyaltyBalance);
